import type { SomethingWithState, OnAddToBoard } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export enum ChasmState {
	TOP = "TOP",
	NORMAL = "NORMAL",
}

export class Chasm extends PhysicalThing implements SomethingWithState, OnAddToBoard {
	static key = "Chasm";
	private state: ChasmState = ChasmState.TOP;
	passable: boolean = false;

	constructor(xy: XY) {
		super(xy, true);
	}

	setPassable(value: boolean): void {
		this.passable = value;
		this.blocksMovement = !value;
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	override isGasPermeable(): boolean {
		return true;
	}

	onAddToBoard(): void {
		const northXY = this.xy.add(0, -1);
		if (this.board!.isInBounds(northXY)) {
			const hasChasm = this.board!.getThingsAt(northXY).some((t) => t instanceof Chasm);
			this.state = hasChasm ? ChasmState.NORMAL : ChasmState.TOP;
		} else {
			this.state = ChasmState.NORMAL;
		}
	}

	getState(): ChasmState {
		return this.state;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), state: this.state, passable: this.passable };
	}

	static deserialize(data: any): Chasm {
		const c = new Chasm(deserializeXY(data.xy));
		c.visualId = data.visualId;
		c.state = data.state ?? ChasmState.TOP;
		c.setPassable(data.passable ?? false);
		return c;
	}
}
